import * as React from 'react'

function SvgIcSearch(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M15.7 14.5h-.8l-.3-.3A6.7 6.7 0 104.4 5.4a6.8 6.8 0 00.7 9.5 6.7 6.7 0 008.8 0l.3.3v.8l5.2 5.2 1.5-1.5zm-6.2 0a4.7 4.7 0 114.7-4.7 4.7 4.7 0 01-4.7 4.7z" />
    </svg>
  )
}

export default SvgIcSearch
